import Cookies from 'js-cookie';
import api from './Axios';

const setAuthHeaders = ({ authToken, userID, roleID, appType = 'eFAST' }) => {
  if (authToken) {
    // expires: 1 → persists 1 day (survives browser close/reopen, not just refresh)
    Cookies.set('access_token', authToken, { expires: 1 });
    api.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
  } else {
    Cookies.remove('access_token');
    delete api.defaults.headers.common['Authorization'];
  }

  if (userID) {
    api.defaults.headers.common['x-user-id'] = userID;
  } else {
    delete api.defaults.headers.common['x-user-id'];
  }

  if (roleID) {
    api.defaults.headers.common['x-role-id'] = roleID;
  } else {
    delete api.defaults.headers.common['x-role-id'];
  }

  if (appType) {
    api.defaults.headers.common['x-app-type'] = appType;
  } else {
    delete api.defaults.headers.common['x-app-type'];
  }
};

export default setAuthHeaders;
